<template>
    <div>
        <h4 class="reclamation-add__row">
            <strong v-text="'Tytuł: '" />
            <span v-text="title" />
        </h4>

        <h5 class="reclamation-add__row">
            <strong v-text="'Sieć: '" />
            <span v-text="network.name" />
        </h5>

        <h5 class="reclamation-add__row">
            <strong v-text="'Sklep: '" />
            <span v-text="`${merchant.name}, ${merchant.fullAddress}`" />
        </h5>

        <h5 class="reclamation-add__row">
            <strong v-text="'Data: '" />
            <span v-text="$moment().format('DD-MM-YYYY')" />
        </h5>

        <h5 class="reclamation-add__row">
            <strong v-text="'Kontrahent: '" />
            <span v-text="retrData.contractor" />
        </h5>

        <h5 class="reclamation-add__row">
            <strong v-text="'Reklamowana pozycja retra: '" />
            <span v-text="retrData.element" />
        </h5>

        <h5 v-if="form.value" class="reclamation-add__row">
            <strong v-text="'Wartość obrotu z dokumentów zakupowych: '" />
            <span>
                {{ form.value | currency }}
            </span>
        </h5>

        <h5 class="reclamation-add__row">
            <strong v-text="'Załączniki: '" />

            <ul v-if="form.files.length" class="modal-reclamation__file-list mt-3">
                <li v-for="(file, index) in form.files" :key="index">
                    {{ file.name }} ({{ file.size | filesize }})
                </li>
            </ul>
        </h5>

        <h5 class="reclamation-add__row">
            <strong v-text="'Opis: '" />
            <span v-text="form.description" />
        </h5>

        <p v-if="errorMessage" class="text-danger" v-text="errorMessage" />
    </div>
</template>

<script>
import reclamationMixin from './reclamation.mixin.js'

export default {
    mixins: [reclamationMixin],

    props: {
        form: {
            type: Object,
            required: true
        },
        errorMessage: {
            type: String,
            default: ''
        }
    },

    computed: {

        network() {
            return this.merchant.network
        }
    }
}
</script>

<style lang="scss">
.reclamation-add__row {
    strong {
        font-weight: 600;
    }
    span {
        font-weight: 400;
        color: var(--text-gray);
    }
}
</style>
